import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { headers, url } from "../../utils/const";
import { Link } from "react-router-dom";
import "./player-management.css";

const Player = () => {
  const [amountRetiro, setAmountRetiro] = useState();
  const [playerToPay, setPlayerToPay] = useState();
  const [disabled, setDisabled] = useState(false);
  const [credit, setCredit] = useState({ amount: "", player: {} });
  const [show, setShow] = useState(false);
  const [showRetiro, setShowRetiro] = useState(false);
  const [showCredit, setShowCredit] = useState(false);
  const [name, setName] = useState("");
  const [customer, setCustomer] = useState("");
  const [point, setPoint] = useState({});
  const [level, setLevel] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [dateFilter, setDateFilter] = useState({ init: "", end: "" });
  const [listPlayer, setListPlayer] = useState([]);
  const [playerAddCredit, setPlayerAddCredit] = useState();
  const [filter, setFilter] = useState("");
  const [presenceLoading, setPresenceLoading] = useState("");
  const [player, setPlayer] = useState({
    name: "",
    document: {
      type: "cedula",
      number: "",
    },
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    point: localStorage.getItem("point"),
    register: localStorage.getItem("user"),
  });
useEffect(() => {
  if (localStorage.getItem("level") !== "4")
    return (window.location.href = "/");
}, []);
  useEffect(() => {
    (async () => {
      const res = await fetch(`${url}/player/data`, {
        method: "get",
        headers: headers,
      });
      const data = await res.json();
      setListPlayer(data.player);
    })();
  }, [setListPlayer]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseCredit = () => setShowCredit(false);
  const handleShowRetiro = (element) => {
    setAmountRetiro(() => {
      return element.credit.retiro.find((ret) => ret.paid === false).amount;
    });
    setPlayerToPay(element);
    setShowRetiro(true);
  };
  const handleCloseRetiro = () => setShowRetiro(false);
  const handleShowCredit = (element) => {
    setPlayerAddCredit(element);
    setShowCredit(true);
    setDisabled(false);
  };

  const OnChangeCustomer = (e) => setCustomer(e.target.value);
  const OnChangePlayerName = (e) =>
    setPlayer({ ...player, name: e.target.value });
  const OnChangePlayerDocumentType = (e) =>
    setPlayer({
      ...player,
      document: { type: e.target.value, number: player.document.number },
    });
  const OnChangePlayerDocumentNumber = (e) =>
    setPlayer({
      ...player,
      document: { number: e.target.value, type: player.document.type },
    });
  const OnChangePlayerPhone = (e) =>setPlayer({ ...player, phone: e.target.value });
  const OnChangePlayerEmail = (e) => setPlayer({ ...player, email: e.target.value });
  const OnChangePlayerPassword = (e) => setPlayer({ ...player, password: e.target.value });
  const OnChangePlayerConfirmPassword = (e) => setPlayer({ ...player, confirmPassword: e.target.value });
  const OnChangePlayerAddCrdit = (e) => setCredit({ player: playerAddCredit, amount: e.target.value });
  const handleCloseFilter = () => setShowFilter(false);
  const handleShowFilter = () => setShowFilter(true);

  const CreatePlayer = async () => {
    if (player.password !== player.confirmPassword) {
      alert("Las contraseñas no coinciden");
      return;
    }
    const res = await fetch(`${url}/player`, {
      method: "post",
      headers: headers,
      body: JSON.stringify(player),
    });
    const data = await res.json();
    if (res.ok && data && data.hasOwnProperty("player")) {
      setListPlayer(data.player);
      alert(data.msg);
      setPlayer({
        name: "",
        document: {
          type: "cedula",
          number: "",
        },
        phone: "",
        email: "",
        password: "",
        confirmPassword: "",
        point: localStorage.getItem("point"),
        register: localStorage.getItem("user"),
      });
      handleClose();
    } else {
      alert(data?.msg || data?.message || data || "No se pudo registrar el jugador");
    }
  };

  /**Agregar Credito */
  const AddCredit = async () => {
    setDisabled(true);
    const res = await fetch(`${url}/player/add-credit`, {
      method: "post",
      headers: headers,
      body: JSON.stringify(credit),
    });
    const data = await res.json();
    alert(data.msg);
    handleCloseCredit();
    window.location.reload();
  };

  /**Pagar Credito */
  const PayCredit = async () => {
    setDisabled(true);
    const res = await fetch(`${url}/player/retiro-credito`, {
      method: "post",
      headers: headers,
      body: JSON.stringify({ player: playerToPay, amount: amountRetiro }),
    });
    const data = await res.json();
    alert(data.msg);
    handleCloseCredit();
    window.location.reload();
  };

  const activatePlayerInBank = async (selectedPlayer) => {
    setPresenceLoading(selectedPlayer._id);
    try {
      const res = await fetch(`${url}/player/presence/activate/${selectedPlayer._id}`, {
        method: "post",
        headers,
        body: JSON.stringify({}),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.msg || "No se pudo activar el jugador");
      setListPlayer((players) => players.map((item) => item._id === selectedPlayer._id
        ? { ...item, inBank: true, presence: data.presence }
        : item));
      alert(data.msg || "Jugador activo en banca");
    } catch (error) {
      alert(error.message || "Error de conexión al activar el jugador");
    } finally {
      setPresenceLoading("");
    }
  };

  const filteredPlayers = listPlayer.filter((player) =>
    player.name.toLowerCase().includes(filter.toLowerCase()) ||player.phone.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className="player-page">
      <div className="player-panel">
      <div className="player-header">
        <div>
          <span className="player-eyebrow">Punto de venta</span>
          <h1>Control de jugadores</h1>
          <p>Registra jugadores, consulta balances y administra recargas.</p>
        </div>
        <div className="player-header-actions">
          <Link to="/bet" className="btn btn-outline-light">Volver a venta</Link>
          <button type="button" className="btn btn-light player-register-btn" onClick={handleShow}>
            <span aria-hidden="true">＋</span> Registrar jugador
          </button>
        </div>
      </div>
      <div className="player-content">
        <div className="player-toolbar">
          <div className="player-count"><strong>{filteredPlayers.length}</strong> {filteredPlayers.length === 1 ? "jugador" : "jugadores"}</div>
          <div className="player-search">
            <span aria-hidden="true">⌕</span>
            <input
              type="text"
              className="form-control"
              placeholder="Filtrar por nombre o Celular"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </div>
        </div>
        <div className="table-responsive player-table-wrap">
          <table className="table player-table align-middle">
            <thead>
              <tr>
                <th>Num</th>
                <th>Nombre</th>
                <th>Telefono</th>
                <th>Credito</th>
                <th>Estado</th>
                <th>Accion</th>
              </tr>
            </thead>
            <tbody>
              {filteredPlayers.length > 0 ? (
                filteredPlayers.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.phone}</td>
                    <td>
                      {item.credit.balance.toFixed(2)}{" "}
                      {item.credit.retiro.some((ret) => ret.paid === false) ? (
                        <button onClick={() => handleShowRetiro(item)}>
                          Retirar
                        </button>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>
                      <span className={item.inBank ? "badge bg-success" : (item.activated ? "badge bg-secondary" : "badge bg-danger")}>
                        {item.inBank ? "En banca" : (item.activated ? "Fuera de banca" : "Desactivado")}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          type="button"
                          className={`btn btn-sm ${item.inBank ? "btn-outline-success" : "btn-primary"}`}
                          disabled={!item.activated || item.inBank || presenceLoading === item._id}
                          onClick={() => activatePlayerInBank(item)}
                        >
                          {presenceLoading === item._id ? "Activando..." : (item.inBank ? "Activo en banca" : "Activar en banca")}
                        </button>
                        <button
                          className="btn btn-sm btn-success player-credit-btn"
                          onClick={() => handleShowCredit(item)}
                        >
                          Agregar crédito
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No se encontraron jugadores</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      </div>
      <Modal show={show} onHide={handleClose} size="lg" centered dialogClassName="player-modal">
        <Modal.Header closeButton>
          <Modal.Title>Registrar Nuevo Jugador</Modal.Title>
        </Modal.Header>
        <form>
          <Modal.Body>
            <div className="row g-3">
              <div className="col-6 form-group">
                <div className="col-12 row">
                  <div className="col-6">
                    <label className="col-12">Tipo Documento</label>
                    <select
                      className="form-select"
                      value={player.document.type}
                      onChange={OnChangePlayerDocumentType}
                    >
                      <option value={"1"}>Cedula</option>
                      <option value={"2"}>Pasaporte</option>
                    </select>
                  </div>
                  <div className="col-6">
                    <div className="col-12">
                      <label>Numero Documento</label>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      value={player.document.number}
                      onChange={OnChangePlayerDocumentNumber}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="col-6 form-group">
                <div className="col-12">
                  <label>Nombre Del Jugador</label>
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    className="form-control"
                    value={player.name}
                    onChange={OnChangePlayerName}
                  ></input>
                </div>
              </div>
              <div className="col-6 form-group">
                <div className="col-12"><label>Contraseña</label></div>
                <input
                  type="password"
                  className="form-control"
                  minLength="8"
                  autoComplete="new-password"
                  value={player.password}
                  onChange={OnChangePlayerPassword}
                />
              </div>
              <div className="col-6 form-group">
                <div className="col-12"><label>Confirmar contraseña</label></div>
                <input
                  type="password"
                  className="form-control"
                  minLength="8"
                  autoComplete="new-password"
                  value={player.confirmPassword}
                  onChange={OnChangePlayerConfirmPassword}
                />
              </div>
              <div className="col-6 form-group">
                <div className="col-12">
                  <label>Telefono(Celular)</label>
                </div>
                <div className="col-12">
                  <input
                    type="phone"
                    className="form-control"
                    value={player.phone}
                    onChange={OnChangePlayerPhone}
                  ></input>
                </div>
              </div>
              <div className="col-6 form-group">
                <div className="col-12">
                  <label>Correo Electronico:</label>
                </div>
                <div className="col-12">
                  <input
                    type="email"
                    className="form-control"
                    value={player.email}
                    onChange={OnChangePlayerEmail}
                  ></input>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cerrar</button>
            <button type="button" className="btn btn-primary" onClick={CreatePlayer}>
              Registrar jugador
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal show={showCredit} size="sm" className="bg-info" centered>
        <Modal.Header>
          <Modal.Title>
            <div className=""> Agregar Credito:</div>
            <div className="">{playerAddCredit ? playerAddCredit.name : ""}</div>
            <div className="">Celular</div>
            <div className="">{playerAddCredit ? playerAddCredit.phone : ""}</div>
            
          </Modal.Title>
        </Modal.Header>
        <form>
          <Modal.Body>
            <div className="col-12 row">
              <div className="col-12 form-group">
                <div className="col-12 row">
                  <div className="col-12">
                    <div className="col-12">
                      <label>Monto (RD$.)</label>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      value={credit.amount}
                      onChange={OnChangePlayerAddCrdit}
                    ></input>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" onClick={handleCloseCredit}>Cerrar</button>
            <button type="button" onClick={AddCredit} disabled={disabled}>
              Agregar
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal show={showRetiro} size="sm" className="bg-info" centered>
        <Modal.Header>
          <Modal.Title>Retiro de Credito</Modal.Title>
        </Modal.Header>
        <form>
          <Modal.Body>
            <div className="col-12 row">
              <div className="col-12 form-group">
                <div className="col-12 row">
                  <div className="col-12">
                    Nombre: {playerToPay ? playerToPay.name : ""}
                  </div>
                  <div className="col-12">
                    Documento: {playerToPay ? playerToPay.document.number : ""}
                  </div>
                  <div className="col-12">
                    <div className="col-12">
                      <label>Monto RD$.: {amountRetiro}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" onClick={handleCloseCredit}>Cerrar</button>
            <button type="button" onClick={PayCredit} disabled={disabled}>
              Pagar
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default Player;
